import {YamlLine} from './yaml.line';
import get = Reflect.get;
import {EnvironmentKind} from '@mrp-brasil/nick-data-commons';

const CNAB_EOL = '\r\n';

export class YamlGenerate {

    public static BANK: any = {

        santander: {
            code: '033',
            retorno: {
                240: [
                    {
                        name: 'header_arquivo',
                        check: [{
                            field: 'tipo_registro',
                            value: '0'
                        }]
                    },
                    {
                        name: 'header_lote',
                        check: [{
                            field: 'tipo_registro',
                            value: '1'
                        }]
                    },
                    {
                        name: 'detail_t',
                        repeat: true,
                        group: 'detail',
                        check: [
                            {
                                field: 'tipo_registro',
                                value: '3'
                            },
                            {
                                field: 'cod_segmento',
                                value: 'T'
                            }
                        ]
                    },
                    {
                        name: 'detail_u',
                        repeat: true,
                        group: 'detail',
                        check: [
                            {
                                field: 'tipo_registro',
                                value: '3'
                            },
                            {
                                field: 'cod_segmento',
                                value: 'U'
                            }
                        ]
                    },
                    {
                        name: 'trailer_lote',
                        check: [{
                            field: 'tipo_registro',
                            value: '5'
                        }]
                    },
                    {
                        name: 'trailer_arquivo',
                        check: [{
                            field: 'tipo_registro',
                            value: '9'
                        }]
                    }
                ]
            }
        },
        bradesco: {
            code: '237',
            retorno: {
                400: [
                    {
                        name: 'header_arquivo',
                        check: [{
                            field: 'indetificacao_registro',
                            value: '0'
                        }]
                    },
                    {
                        name: 'detail_type_1',
                        repeat: true,
                        group: 'detail',
                        check: [
                            {
                                field: 'identificacao_registro',
                                value: '1'
                            }
                        ]
                    },
                    {
                        name: 'trailer_arquivo',
                        check: [{
                            field: 'indentificacao_registro',
                            value: '9'
                        }]
                    }
                ]
            }
        },
        serasa: {
            code: 'Concentre',
            retorno: {
                Concentre:
                    [
                        {
                            name: 'header_arquivo',
                            group: 'header',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'B49C'
                            }]
                        },
                        {
                            name: 'detail_type_1',
                            group: 'detail',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'P002'
                                }
                            ]
                        },
                        {
                            name: 'detail_type_2',
                            group: 'detail',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'I001'
                                }
                            ]
                        },
                        {
                            name: 'trailer_arquivo',
                            group: 'trailer',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'T999'
                            }]
                        },
                        {
                            name: 'RegI100Conf00',
                            group: 'I100',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I10000'
                            }]
                        },
                        {
                            name: 'RegI100Conf99',
                            group: 'I100',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I10099'
                            }]
                        },
                        {
                            name: 'RegI101Conf00',
                            group: 'I101',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I10100'
                            }]
                        },
                        {
                            name: 'RegI102Conf00',
                            group: 'I102',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I10200'
                            }]
                        },
                        {
                            name: 'RegI110Conf00',
                            group: 'I110',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I11000'
                            }]
                        },
                        {
                            name: 'RegI110Conf01',
                            group: 'I110',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I11001'
                            }]
                        },
                        {
                            name: 'RegI120Conf00',
                            group: 'I120',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I12000'
                            }]
                        },
                        {
                            name: 'RegI120Conf01',
                            group: 'I120',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I12001'
                            }]
                        },
                        {
                            name: 'RegI120Conf02',
                            group: 'I120',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I12002'
                            }]
                        },
                        {
                            name: 'RegI120Conf03',
                            group: 'I120',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I12003'
                            }]
                        },
                        {
                            name: 'RegI130Conf00',
                            group: 'I130',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I13000'
                            }]
                        },
                        {
                            name: 'RegI130Conf01',
                            group: 'I130',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I13001'
                            }]
                        },
                        {
                            name: 'RegI140Conf00',
                            group: 'I140',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I14000'
                            }]
                        },
                        {
                            name: 'RegI140Conf01',
                            group: 'I140',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I14001'
                            }]
                        },
                        {
                            name: 'RegI140Conf02',
                            group: 'I140',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I14002'
                            }]
                        },
                        {
                            name: 'RegI140Conf03',
                            group: 'I140',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I14003'
                            }]
                        },
                        {
                            name: 'RegI150Conf00',
                            group: 'I150',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I15000'
                            }]
                        },
                        {
                            name: 'RegI150Conf01',
                            group: 'I150',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I15001'
                            }]
                        },
                        {
                            name: 'RegI150Conf02',
                            group: 'I150',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I15002'
                            }]
                        },
                        {
                            name: 'RegI160Conf00',
                            group: 'I160',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I16000'
                            }]
                        },
                        {
                            name: 'RegI160Conf01',
                            group: 'I160',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I16001'
                            }]
                        },
                        {
                            name: 'RegI160Conf02',
                            group: 'I160',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I16002'
                            }]
                        },
                        {
                            name: 'RegI170Conf01',
                            group: 'I170',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I17001'
                            }]
                        },
                        {
                            name: 'RegI170Conf02',
                            group: 'I170',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I17002'
                            }]
                        },
                        {
                            name: 'RegI220Conf00',
                            group: 'I220',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I22000'
                            }]
                        },
                        {
                            name: 'RegI220Conf01',
                            group: 'I220',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I22001'
                            }]
                        },
                        {
                            name: 'RegI220Conf02',
                            group: 'I220',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I22002'
                            }]
                        },
                        {
                            name: 'RegI220Conf03',
                            group: 'I220',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I22003'
                            }]
                        },
                        {
                            name: 'RegI220Conf04',
                            group: 'I220',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I22004'
                            }]
                        },
                        {
                            name: 'RegI230Conf00',
                            group: 'I230',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I23000'
                            }]
                        },
                        {
                            name: 'RegI230Conf01',
                            group: 'I230',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I23001'
                            }]
                        },
                        {
                            name: 'RegI230Conf02',
                            group: 'I230',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I23002'
                            }]
                        },
                        {
                            name: 'RegI230Conf03',
                            group: 'I230',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I23003'
                            }]
                        },
                        {
                            name: 'RegI310Conf00',
                            group: 'I310',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I31000'
                            }]
                        },
                        {
                            name: 'RegI310Conf01',
                            group: 'I310',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I31001'
                            }]
                        },
                        {
                            name: 'RegI310Conf02',
                            group: 'I310',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I31002'
                            }]
                        },
                        {
                            name: 'RegI310Conf03',
                            group: 'I310',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I31003'
                            }]
                        },
                        {
                            name: 'RegI310Conf04',
                            group: 'I310',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I31004'
                            }]
                        },
                        {
                            name: 'RegI310Conf99',
                            group: 'I310',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I31099'
                            }]
                        },
                        {
                            name: 'RegI410Conf00',
                            group: 'I410',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I41000'
                            }]
                        },
                        {
                            name: 'RegI410Conf01',
                            group: 'I410',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I41001'
                            }]
                        },
                        {
                            name: 'RegI410Conf02',
                            group: 'I410',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I41002'
                            }]
                        },
                        {
                            name: 'RegI410Conf99',
                            group: 'I410',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I41099'
                            }]
                        },
                        {
                            name: 'RegI420Conf00',
                            group: 'I420',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I42000'
                            }]
                        },
                        {
                            name: 'RegI420Conf99',
                            group: 'I420',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I42099'
                            }]
                        },
                        {
                            name: 'RegI430Conf00',
                            group: 'I430',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I43000'
                            }]
                        },
                        {
                            name: 'RegI450Conf00',
                            group: 'I450',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I45000'
                            }]
                        },
                        {
                            name: 'RegI450Conf01',
                            group: 'I450',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I45001'
                            }]
                        },
                        {
                            name: 'RegI450Conf02',
                            group: 'I450',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I45002'
                            }]
                        },
                        {
                            name: 'RegI450Conf03',
                            group: 'I450',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I45003'
                            }]
                        },
                        {
                            name: 'RegI450Conf99',
                            group: 'I450',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I45099'
                            }]
                        },
                        {
                            name: 'RegI470Conf00',
                            group: 'I470',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I47000'
                            }]
                        },
                        {
                            name: 'RegI470Conf99',
                            group: 'I470',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I47099'
                            }]
                        },
                        {
                            name: 'RegI480Conf00',
                            group: 'I480',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I48000'
                            }]
                        },
                        {
                            name: 'RegI480Conf99',
                            group: 'I480',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I48099'
                            }]
                        },
                        {
                            name: 'RegI490Conf00',
                            group: 'I490',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49000'
                            }]
                        },
                        {
                            name: 'RegI490Conf01',
                            group: 'I490',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49001'
                            }]
                        },
                        {
                            name: 'RegI490Conf02',
                            group: 'I490',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49002'
                            }]
                        },
                        {
                            name: 'RegI490Conf03',
                            group: 'I490',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49003'
                            }]
                        },
                        {
                            name: 'RegI490Conf99',
                            group: 'I490',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49099'
                            }]
                        },
                        {
                            name: 'RegI495Conf00',
                            group: 'I495',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49500'
                            }]
                        },
                        {
                            name: 'RegI495Conf01',
                            group: 'I495',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49501'
                            }]
                        },
                        {
                            name: 'RegI495Conf99',
                            group: 'I495',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I49599'
                            }]
                        },
                        {
                            name: 'RegI500Conf00',
                            group: 'I500',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I50000'
                            }]
                        },
                        {
                            name: 'RegI500Conf99',
                            group: 'I500',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I50099'
                            }]
                        },
                        {
                            name: 'RegI520Conf00',
                            group: 'I520',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I52000'
                            }]
                        },
                        {
                            name: 'RegI520Conf01',
                            group: 'I520',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I52001'
                            }]
                        },
                        {
                            name: 'RegI520Conf99',
                            group: 'I520',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I52099'
                            }]
                        },
                        {
                            name: 'RegI530Conf00',
                            group: 'I530',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I53000'
                            }]
                        },
                        {
                            name: 'RegI530Conf99',
                            group: 'I530',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I53099'
                            }]
                        },
                        {
                            name: 'RegI540Conf00',
                            group: 'I540',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I54000'
                            }]
                        },
                        {
                            name: 'RegI540Conf99',
                            group: 'I540',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I54099'
                            }]
                        },
                        {
                            name: 'RegI550Conf00',
                            group: 'I550',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I55000'
                            }]
                        },
                        {
                            name: 'RegI550Conf01',
                            group: 'I550',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I55001'
                            }]
                        },
                        {
                            name: 'RegI550Conf99',
                            group: 'I550',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I55099'
                            }]
                        },
                        {
                            name: 'RegI560Conf00',
                            group: 'I560',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I56000'
                            }]
                        },
                        {
                            name: 'RegI600Conf00',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60000'
                            }]
                        },
                        {
                            name: 'RegI600Conf01',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60001'
                            }]
                        },
                        {
                            name: 'RegI600Conf02',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60002'
                            }]
                        },
                        {
                            name: 'RegI600Conf03',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60003'
                            }]
                        },
                        {
                            name: 'RegI600Conf04',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60004'
                            }]
                        },
                        {
                            name: 'RegI600Conf93',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60093'
                            }]
                        },
                        {
                            name: 'RegI600Conf95',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60095'
                            }]
                        },
                        {
                            name: 'RegI600Conf96',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60096'
                            }]
                        },
                        {
                            name: 'RegI600Conf97',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60097'
                            }]
                        },
                        {
                            name: 'RegI600Conf98',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60098'
                            }]
                        },
                        {
                            name: 'RegI600Conf99',
                            group: 'I600',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'I60099'
                            }]
                        },
                        {
                            name: 'RegF900RSPG0',
                            group: 'RSPG',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'F900RSPG0'
                            }]
                        },
                        {
                            name: 'RegF900RSPG1',
                            group: 'RSPG',
                            check: [{
                                field: 'identificacao_registro',
                                value: 'F900RSPG1'
                            }]
                        },

                        {
                            name: 'RegF900SSRSRF00',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSRF00'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSRF01',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSRF01'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSRF02',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSRF02'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSRF03',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSRF03'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSF00',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSF00'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSF01',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSF01'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSF02',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSF02'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSF03',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSF03'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSF04',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSF04'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSF05',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSF05'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSU00',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSU00'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSU01',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSU01'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSU02',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSU02'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SSRSSU03',
                            group: 'SSRS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SSRSSU03'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF01',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF01'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF02',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF02'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF03',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF03'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF04',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF04'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF05',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF05'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF98',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF98'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHF99',
                            group: 'RSHF',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHF99'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM501',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM501'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM502',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM502'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM503',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM503'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM504',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM504'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM505',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM505'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM506',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM506'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM507',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM507'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSM508',
                            group: 'RSM5',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSM508'
                                }
                            ]
                        },
                        {
                            name: 'RegF900MSM70',
                            group: 'MSM7',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900MSM70'
                                }
                            ]
                        },
                        {
                            name: 'RegF900MSM71',
                            group: 'MSM7',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900MSM71'
                                }
                            ]
                        },
                        {
                            name: 'RegF900AL23',
                            group: 'AL23',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900AL23'
                                }
                            ]
                        },
                        {
                            name: 'RegF900MSM40',
                            group: 'MSM4',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900MSM40'
                                }
                            ]
                        },
                        {
                            name: 'RegF900MSM41',
                            group: 'MSM4',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900MSM41'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSDC001',
                            group: 'RSDC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSDC001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSDC002',
                            group: 'RSDC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSDC002'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSDC003',
                            group: 'RSDC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSDC003'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSDC099',
                            group: 'RSDC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSDC099'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHP',
                            group: 'RSHP',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHP'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSIV0',
                            group: 'RSIV',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSIV0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSIV99',
                            group: 'RSIV',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSIV99'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSRD0',
                            group: 'RSRD',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSRD0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSRD1',
                            group: 'RSRD',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSRD1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSTM0',
                            group: 'RSTM',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSTM0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSTM1',
                            group: 'RSTM',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSTM1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRF2001',
                            group: 'NRF2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRF2001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900PXSA0',
                            group: 'PXSA',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900PXSA0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSGE0',
                            group: 'RSGE',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSGE0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSI100',
                            group: 'RSI1',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSI100'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRF2002',
                            group: 'NRF2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRF2002'
                                }
                            ]
                        },
                        {
                            name: 'RegF900PXSA1',
                            group: 'PXSA',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900PXSA1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSGE1',
                            group: 'RSGE',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSGE1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSI199',
                            group: 'RSI1',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSI199'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRF2009',
                            group: 'NRF2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRF2009'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSCB01',
                            group: 'RSCB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSCB01'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSGJ1',
                            group: 'RSGJ',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSGJ1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSIR00',
                            group: 'RSIR',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSIR00'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRF20',
                            group: 'NRF2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRF20'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSCB02',
                            group: 'RSCB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSCB02'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSGJ3',
                            group: 'RSGJ',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSGJ3'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSIR99',
                            group: 'RSIR',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSIR99'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRF21',
                            group: 'NRF2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRF21'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSCB03',
                            group: 'RSCB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSCB03'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSGJ9',
                            group: 'RSGJ',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSGJ9'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSPI001',
                            group: 'RSPI',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSPI001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900P8RC0',
                            group: 'P8RC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900P8RC0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSCB04',
                            group: 'RSCB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSCB04'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHI001',
                            group: 'RSHI',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHI001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSPI002',
                            group: 'RSPI',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSPI002'
                                }
                            ]
                        },
                        {
                            name: 'RegF900P8RC1',
                            group: 'P8RC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900P8RC1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSCB99',
                            group: 'RSCB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSCB99'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSHI009',
                            group: 'RSHI',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSHI009'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RSPI009',
                            group: 'RSPI',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RSPI009'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPC2000',
                            group: 'SPC2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPC2000'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPC2001',
                            group: 'SPC2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPC2001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPC2002',
                            group: 'SPC2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPC2002'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPC2003',
                            group: 'SPC2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPC2003'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPC2007',
                            group: 'SPC2',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPC2007'
                                }
                            ]
                        },
                        {
                            name: 'RegF900CRE61',
                            group: 'CRE6',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900CRE61'
                                }
                            ]
                        },
                        {
                            name: 'RegF900CRE60',
                            group: 'CRE6',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900CRE60'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRC900',
                            group: 'NRC9',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRC900'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRC901',
                            group: 'NRC9',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRC901'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRC902',
                            group: 'NRC9',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRC902'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRC903',
                            group: 'NRC9',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRC903'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRC904',
                            group: 'NRC9',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRC904'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NRC905',
                            group: 'NRC9',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NRC905'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPCS000',
                            group: 'SPCS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPCS000'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPCS001',
                            group: 'SPCS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPCS001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPCS002',
                            group: 'SPCS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPCS002'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPCS003',
                            group: 'SPCS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPCS003'
                                }
                            ]
                        },
                        {
                            name: 'RegF900SPCS007',
                            group: 'SPCS',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900SPCS007'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RKP7001',
                            group: 'RKP7',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RKP7001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900RKP7009',
                            group: 'RKP7',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900RKP7009'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NREC01',
                            group: 'NREC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NREC01'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NREC02',
                            group: 'NREC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NREC02'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NREC03',
                            group: 'NREC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NREC03'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NREC04',
                            group: 'NREC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NREC04'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NREC05',
                            group: 'NREC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NREC05'
                                }
                            ]
                        },
                        {
                            name: 'RegF900NREC06',
                            group: 'NREC',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900NREC06'
                                }
                            ]
                        },
                        {
                            name: 'RegF900PXSB0',
                            group: 'PXSB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900PXSB0'
                                }
                            ]
                        },
                        {
                            name: 'RegF900PXSB1',
                            group: 'PXSB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900PXSB1'
                                }
                            ]
                        },
                        {
                            name: 'RegF900PXSB2',
                            group: 'PXSB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900PXSB2'
                                }
                            ]
                        },
                        {
                            name: 'RegF900PXSB3',
                            group: 'PXSB',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900PXSB3'
                                }
                            ]
                        },
                        {
                            name: 'RegF900P8JU001',
                            group: 'P8JU',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900P8JU001'
                                }
                            ]
                        },
                        {
                            name: 'RegF900P8JU002',
                            group: 'P8JU',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900P8JU002'
                                }
                            ]
                        },
                        {
                            name: 'RegF900P8JU009',
                            group: 'P8JU',
                            check: [
                                {
                                    field: 'identificacao_registro',
                                    value: 'F900P8JU009'
                                }
                            ]
                        }
                    ]
            }
        }
    };

    public static generateRemessaCnab(files: any, cnabtype = 400, bankcode = '237'): any {
        try {
            const yamls: any[] = [];

            const getData = (object: any) => {
                Object.keys(object).forEach((key: string) => {
                    if (object[key] instanceof Array) {
                        object[key].forEach((data: any) => {
                            getData(data);
                        });
                    } else {
                        const layout = YamlLine.readYaml(`../node_modules/@mrp-brasil/nick-process-node/hook/bank/shipment/banks/cnab${cnabtype}/${bankcode}/remessa/${key}.yml`);
                        yamls.push({
                            layout,
                            data: object[key]
                        });
                    }
                });
            };

            getData(files);

            const infos = yamls.map((i, index) => {
                return YamlLine.makeLine(i.layout, i.data);
            });

            const infosLine = infos.map(i => {
                return i.line;
            });

            return infosLine.join(CNAB_EOL);
        } catch (e) {
            console.log(e);
        }
    }

    public static generateRetornoCnab(reference: any[], cnabtype = 400, bankcode = '237', retorno: {
        split: (arg0: string) => void
    }, environment: EnvironmentKind): any {
        try {
            const yamls: any = [];

            const lines: any = retorno.split('\n');
            // tslint:disable-next-line:prefer-const
            let receivedData = lines;
            let linesLength = 0;
            if (lines.length == 2) {
                // tslint:disable-next-line:prefer-const
                let aux = [];
                aux.push(receivedData[0].slice(0, 400));
                receivedData[0] = receivedData[0].slice(400);
                do {
                    linesLength = receivedData[0].length;
                    aux.push(receivedData[0].slice(0, 115));
                    receivedData[0] = receivedData[0].slice(115);
                }
                while (linesLength > 115);
                receivedData = aux;
            }
            const envPrefix = environment == EnvironmentKind.DEV ? '../node_modules/@mrp-brasil/nick-process-node/lib/hook/bank/shipment/banks/cnab' : '/ng-app/node_modules/@mrp-brasil/nick-process-node/lib/hook/bank/shipment/banks/cnab';
            receivedData.forEach((line: any) => {
                reference.forEach((ref: any) => {
                    const layout: any = YamlLine.readYaml(`${envPrefix}${cnabtype}/${bankcode}/retorno/${ref.name}.yml`);
                    if (ref.check.every((check: any) => YamlLine.extractDataFromPicture(layout[check.field], line, true) == check.value))
                        yamls.push({
                            layout,
                            name: ref.name,
                            repeat: ref.repeat,
                            group: ref.group,
                            data: line
                        });
                });
            });

            const result: any = {};

            yamls.forEach((i: any, index: number) => {
                const line = YamlLine.readLine(i.layout, i.data);
                if (result[i.group]) {
                    result[i.group].push(line);
                }

                if (!result[i.group]) {
                    result[i.group] = [];
                    result[i.group].push(line);
                }
            });

            return result;
        } catch (e) {
            console.error(`parseRemessaCnab: `, e);
        }
    }
}
